export default {
	install(Vue, options) {
		Vue.prototype.langConfig = {
			curLang: (function () {
				let _hostname = window.location.hostname;
				// if (_hostname.indexOf('en') > -1) {
				// 	return 'en';
				// }
				// if (_hostname.indexOf('kr') > -1) {
				// 	return 'kr';
				// }
				// if (_hostname.indexOf('th') > -1) {
				// 	return 'th';
				// }
				// if (_hostname.indexOf('vn') > -1) {
				// 	return 'vn';
				// }
				return 'th';
			})(),

			txtLang: {
				'th': {
					'LOGO_TXT': 'th.upgoal.com',
					'STATE_ARR': ["", "1st", "HT", "2nd", "FT", "หยุด", "ยกเลิก", "ต่อเวลา", "ต่อเวลา", "ต่อเวลา", "จบ", "การดวลจุดโทษ", "เต็มเวลา", "เลื่อน", "หยุด", "รอผล", "ทอง", ""],
					'NAV_TAB': [
						{
							'id': 0,
							'path': '/',
							'name': 'ผลบอลสด'
						},
						{
							'id': 1,
							'path': '/favorites',
							'name': 'ทีมโปรด'
						},
						{
							'id': 2,
							'path': '/leagues/0/0',
							'name': 'ลีก'
						},
						// {
						// 	'id': 3,
						// 	'path': '/transfer',
						// 	'name': 'Transfer'
						// },
						// {
						// 	'id': 4,
						// 	'path': '/prediction',
						// 	'name': 'Prediction'
						// },
						{
							'id': 5,
							'path': '/news/0',
							'name': 'ข่าว'
						},
					],
					'POP_NAV': [
						{
							'id': 0,
							'name': 'ลีกของฉัน'
						},
						{
							'id': 1,
							'name': 'การตั้ง'
						}
					],
					'DAY_WEEK': ["อาทิตย์", "จันทร์", "อังคาร", "พุธ", "พฤหัส", "ศุกร์", "เสาร์", "วันนี้"],
					'DAY_WEEK_SORT': ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส', 'วันนี้'],
					'CONFIRM': 'ยืนยัน',
					'CANCEL': 'ยกเลิก',
					'TOP_LEAGUES': 'ลีกสูงสุด',
					'MY_LEAGUES': 'ลีกของฉัน',
					'NEWS': 'ข่าว',
					'ALL_LEAUGES': 'ลีกทั้งหมด',
					'ALL_NEWS': 'ข่าวทั้งหมด',
					'NO_DATA': 'ยังไม่มีข้อมูล',
					'LOADING': 'loading...',
				},
			},
			login: {
				'th': {
					'LOGIN': 'เข้าสู่ระบบ',
					'LOGOUT': 'ออกจากระบบ',
					'SIGNUP': 'ลงทะเบียน',
					'SIGN_UP_MORE': 'ลงทะเบียนเพื่อรับเพิ่มเติม',
					'FOLLOW_MATCHES': 'ติดตามแมตช์โปรดของคุณ',
					'VIEW_NEWS': 'ตรวจสอบบริการระดับพรีเมียม เช่น ข่าววีไอพี',
					'SYNC_DEVICES': 'ซิงค์การตั้งค่าระหว่างอุปกรณ์ต่างๆ',
					'CONTINUE_EMAIL': 'ดำเนินการต่อด้วยอีเมล',
					'LOGIN_TIPS': 'การคลิก"ส่งอีเมลต่อไป"แสดงว่าคุณยอมรับ<a href="/terms">ข้อกําหนดในการให้บริการ</a>และ<a href="/privacy">รับทราบนโยบายความเป็นส่วนตัวของเราบนเว็บไซต์</a>ของเรา',
					'BACK': 'ย้อนกลับ',
					'LOGIN_ACCOUNT': 'เข้าสู่ระบบบัญชีที่มีอยู่',
					'CREATE_ACCOUNT': 'สร้างบัญชีใหม่',
					'REGISTRATION': 'ลงทะเบียนสําเร็จ!',
					'FORGOT': 'ลืมรหัสผ่าน',
					'PASSWORD_RESET': 'อีเมลรีเซ็ตรหัสผ่านถูกส่งถึงคุณแล้ว',
					'RESET': 'รีเซ็ตรหัสผ่าน',
					'RESET_SUCCESS': 'รีเซ็ตรหัสผ่านของคุณสําเร็จแล้ว',
					'ACCOUNT_SUCCESS': 'บัญชีของคุณเปิดใช้งานสําเร็จแล้วและตอนนี้คุณสามารถเข้าสู่ระบบได้แล้ว',
					'NEW_PASSWORD': 'โปรดป้อนที่อยู่อีเมลที่ลงทะเบียนของคุณและเราจะส่งอีเมลยืนยันเพื่อรีเซ็ตรหัสผ่านของคุณ',
					'SEND': 'ส่ง',
					'SAVE': 'บันทึก',
					'GOT_IT': 'รู้แล้ว',
					'EMAIL_FORMAT': 'อีเมลมีรูปแบบไม่ถูกต้องโปรดป้อนอีกครั้ง',
					'LEAST_DIGITS': 'กรุณากรอกอย่างน้อย 6 หลัก',
					'INCONSISTENT': 'รหัสผ่านและรหัสผ่านที่ระบุอีกครั้งไม่ตรงกัน ',
					'REGISTER_VER': 'เราได้ส่งอีเมลยืนยันการลงทะเบียนไปยังที่อยู่อีเมลที่คุณลงทะเบียนไว้ <span>[?1]</span>.<br />โปรดไปที่กล่องจดหมายเพื่อตรวจสอบและยืนยันการลงทะเบียนขอขอบคุณ!',
					'PASSWORD_VER': 'เราได้ส่งอีเมลยืนยันการรีเซ็ตรหัสผ่านไปยังที่อยู่อีเมลที่คุณลงทะเบียนไว้ <span>[?1]</span>.<br />โปรดไปที่กล่องจดหมายเพื่อตรวจสอบและรีเซ็ตรหัสผ่านขอบคุณ! ',
					'EMAIL_REGISTER_TIPS': 'หากคุณยังไม่มีบัญชี ให้<span id="SignUp">ลงทะเบียน</span>',
					'EMAIL_LOGIN_TIPS': 'หากคุณมีบัญชีอยู่แล้ว ให้<span id="LogIn">เข้าสู่ระบบ</span>',
					'SINGUP_TIPS': 'การคลิกปุ่ม "ลงทะเบียน" หมายถึงคุณยอมรับ<a href="/terms">ข้อกำหนดการใช้งาน</a>และรับรองว่าคุณได้อ่านและเข้าใจ<a href="/privacy">นโยบายความเป็นส่วนตัว</a>ของเราที่อยู่บนเว็บไซต์ของเรา',
					'ACCOUNT_NOT_ACTIVE': 'บัญชีไม่ได้เปิดใช้งาน',
					'ACCOUNT_NOT_ACTIVE_TIPS': 'โปรดตรวจสอบอีเมลลงทะเบียนของคุณ <span>[?1]</span> เพื่อค้นหาอีเมลยืนยันการลงทะเบียน โปรดเปิดอีเมลดังกล่าวและทำการเปิดใช้งานบัญชีผ่านลิงก์ที่ได้รับในอีเมล หากคุณไม่ได้รับอีเมล คุณสามารถคลิกที่ปุ่มด้านล่างเพื่อส่งใหม่',
					'SEND_AGAIN': 'ส่งอีเมลยืนยันอีกครั้ง',
					'CLOSE': 'ปิด',
					'REGISTER_AGAIN_TIPS': 'อีเมลยืนยันการลงทะเบียนถูกส่งไปยังที่อยู่อีเมลที่ลงทะเบียนของคุณ <span>[?1] </span><br />โปรดใช้อีเมลนี้เพื่อเปิดใช้งานบัญชีของคุณ<br />หากคุณไม่ได้รับอีเมลคุณสามารถคลิกปุ่มด้านล่างเพื่อส่งอีกครั้ง',
					'RESEND_TIPS': 'เมื่อส่งอีกครั้งลิงก์การยืนยันก่อนหน้านี้จะไม่ถูกต้องโดยอัตโนมัต<br />กล่องจดหมายบางกล่องอาจระบุข้อความว่าเป็นสแปมโดยไม่ได้ตั้งใจ ดังนั้นโปรดตรวจสอบอย่างละเอียด',
					'ACTIVE_FAIL': 'การเปิดใช้งานล้มเหลว',
					'LINK_EXPIRED': 'ลิงก์เปิดใช้งานที่คุณใช้ใช้งานไม่ได้อีกต่อไปโปรดส่งอีเมลยืนยันอีกครั้งโดยลงชื่อเข้าใช้บัญชีของคุณ',
					'PASSWORD_LINK_EXPIRED': 'ลิงก์การยืนยันที่คุณใช้หมดอายุแล้ว หากคุณต้องการกู้คืนรหัสผ่านโปรดส่งคำขอใหม่อีกครั้ง',
					'RETRIEVE_PASSWORD': 'กู้คืนรหัสผ่าน',
					'RESET_PASSWORD_FAIL': 'การรีเซ็ตรหัสผ่านล้มเหลว',
					'PLACEHOLDER_EMAIL': 'Email',
					'PLACEHOLDER_PWD': 'Password again',
					'PLACEHOLDER_PWD2': 'Password',
					'PLACEHOLDER_CODE': 'Verification Code',
				},
			},
			setting: {
				'en': {
					'DARK_MODE': 'Dark mode',
					'SOUND': 'Sound',
					'TIME_ZONE': 'Time zone',
					'ORDER_BY': 'Order matches by:',
					'LEAGUES': 'Leagues',
					'KICK_OFF': 'Kick-off Time',
					'ODDS_TYPES': 'Odds Types:',
					'ODDS_FORMAT': 'Odds Formats:'
				},
				'kr': {
					'DARK_MODE': '다크 모드',
					'SOUND': '사운드',
					'TIME_ZONE': '시간대 설치',
					'ORDER_BY': '선택별:',
					'LEAGUES': '리그',
					'KICK_OFF': '킥오프',
					'ODDS_TYPES': '승률 게임 콘텐츠:',
					'ODDS_FORMAT': '지수도식:'
				},
				'th': {
					'DARK_MODE': 'โหมดมืด',
					'SOUND': 'เสียง',
					'TIME_ZONE': 'เขตเวลา',
					'ORDER_BY': 'เรียงอันดับการแข่งขันตาม:',
					'LEAGUES': 'ชื่อลีก',
					'KICK_OFF': 'เวลาเริ่มเกม',
					'ODDS_TYPES': 'กราฟราคาบอล:',
					'ODDS_FORMAT': 'รูปแบบราคาบอล:'
				},
				'vn': {
					'DARK_MODE': 'Chế độ nền tối',
					'SOUND': 'Âm Thanh',
					'TIME_ZONE': 'Múi giờ',
					'ORDER_BY': 'Trận đấu xếp theo',
					'LEAGUES': 'Tên giải đấu',
					'KICK_OFF': 'Thời gian bắt đầu trận đấu',
					'ODDS_TYPES': 'Cách chơi',
					'ODDS_FORMAT': 'Cách thức hiện thị'
				}
			},
			footer: {
				'en': {
					'FOOTBALL': 'Soccer',
					'SCORE': 'Scores',
					'LEAGUES': 'Leagues',
					'TRANSFER': 'Transfer',
					'PREDICTION': 'Prediction',
					'NEWS': 'News',
					'ABOUT': 'About',
					'TERMS': 'Terms of Service',
					'PRIVACY': 'Privacy Policy',
					'SITMAP': 'Sitmap',
					'FOLLOW_US': 'Follow us',
					'SUB_TITLE': 'Subscription Notification',
					'SUB_INTRO': 'Access regularly to selected match news, match analysis, popular matches, and recent marketing campaigns, etc. Build a deeper connection between Upgoal and sports fans.',
					'SUB_BTN': 'Subscription',
					'NOTE': 'Note: Advertisements on upgoal.com are agreed upon by both parties to the contract. Upgoal does not guarantee the authenticity of the information in above advertisements. Upgoal is not responsible for all transactions between you and the advertisers.',
					'COPY_RIGHT': 'Copyright © 2024 upgoal.com All rights reserved.',
					'COOKIE_TIPS': 'We use cookies for basic functionality and to collect anonymous data for analysis to improve your experience. By understanding how you use our products, we can build better features and provide you with more valuable content and marketing information. For more information about cookies, please see our <a href="/privacy">Privacy Policy</a>. By continuing to use this site you are agreeing to our use of cookies and personal data.',
					'SUB_SUCCESS_TIPS': 'You have successfully subscribed to platform notifications.',
					'CLOSE': 'Close',
					'SUB_ERRO_TIPS': 'Please enter the correct Email format, e.g. xx@xx.com.',
					'SUB_PLACEHOLDER': 'Email Address',
				},
				'kr': {
					'FOOTBALL': '축구',
					'SCORE': '스코어',
					'LEAGUES': '리그',
					'TRANSFER': '이적',
					'PREDICTION': '예측',
					'NEWS': '뉴스',
					'ABOUT': '회사소개',
					'TERMS': '서비스 계약',
					'PRIVACY': '개인정보보호정책',
					'SITMAP': '사이트맵',
					'FOLLOW_US': '팔로우',
					'SUB_TITLE': '구독 알림',
					'SUB_INTRO': '정기적으로 특선 경기 뉴스, 경기 분석, 인기 경기, 최근 마케팅 활동 등의 콘텐츠를 획득하여 vipgoal이 스포츠 팬들과 더욱 깊은 관계를 맺을 수 있도록 합니다.',
					'SUB_BTN': '구독',
					'NOTE': '주의: upgoal.com에서의 광고는 계약 당사자 간의 합의에 따라 이루어집니다. upgoal은 상기 광고 정보의 진실성을 보증하지 않습니다. upgoal은 귀하와 광고주 간의 모든 거래에 대해 어떠한 책임도 지지 않습니다.',
					'COPY_RIGHT': 'Copyright ©2024  upgoal.com All Rights Reserved.',
					'COOKIE_TIPS': '쿠키를 사용하여 기본 기능을 활성화하고 익명 데이터를 수집하여 분석함으로써 귀하의 경험을 개선합니다. 제품을 이용하는 방식을 이해함으로써 더 나은 기능을 구축할 수 있고 더 가치 있는 콘텐츠와 마케팅 정보를 제공할 수 있습니다. 쿠키에 대한 자세한 내용은 당사의 <a href="/privacy">개인정보보호정책</a>을 참조하십시오. 본 사이트를 계속 이용하시면 귀하의 쿠키 및 개인 데이터 이용을 동의하는 것입니다.',
					'SUB_SUCCESS_TIPS': '플랫폼 알림 구독에 성공했습니다.',
					'CLOSE': '닫기',
					'SUB_ERRO_TIPS': '올바른 Email 형식을 입력하십시오. 예: xx@xx.com',
					'SUB_PLACEHOLDER': '이메일 주소',
				},
				'th': {
					'FOOTBALL': 'ฟุตบอล',
					'SCORE': 'คะแนน',
					'LEAGUES': 'ชื่อลีก',
					'TRANSFER': 'ย้าย',
					'PREDICTION': 'ผลการแข่งขันที่คาด',
					'NEWS': 'ข่าว',
					'ABOUT': 'เกี่ยวกับ',
					'TERMS': 'ข้อตกลงการบริการ',
					'PRIVACY': 'นโยบายความเป็นส่วนตัว',
					'SITMAP': 'แผนผังเว็บไซต์',
					'FOLLOW_US': 'ติดตามเรา',
					'SUB_TITLE': 'การแจ้งเตือนการสมัครสมาชิก',
					'SUB_INTRO': 'รับข่าวสารการแข่งขันที่เลือกสรรอย่างเป็นประจำ การวิเคราะห์การแข่งขัน การแข่งขันที่ได้รับความนิยม กิจกรรมการตลาดล่าสุด และเนื้อหาอื่น ๆ เพื่อเชื่อมต่อความสัมพันธ์ที่เข้มแข็งกับ VIPGOAL และผู้สนใจกีฬาได้อย่างลึกซึ้งยิ่งขึ้น',
					'SUB_BTN': 'สมัครสมาชิก',
					'NOTE': 'หมายเหตุ: โฆษณาบน ?1 จัดทำตามข้อตกลงที่ได้รับการตกลงร่วมกันจากทั้งสองฝ่าย ?2 ไม่รับประกันความเป็นจริงของข้อมูลโฆษณาดังกล่าว ?2 ไม่รับผิดชอบต่อการซื้อขายทั้งหมดระหว่างคุณและลูกค้าโฆษณา',
					'COPY_RIGHT': 'สงวนลิขสิทธิ์โดย © ?1 ?2 ',
					'COOKIE_TIPS': 'เราใช้คุกกี้เพื่อการทํางานพื้นฐานและเพื่อรวบรวมข้อมูลที่ไม่ระบุตัวตนเพื่อการวิเคราะห์เพื่อปรับปรุงประสบการณ์ของคุณ ด้วยการทําความเข้าใจว่าคุณใช้ผลิตภัณฑ์ของเราอย่างไรเราสามารถสร้างคุณสมบัติที่ดีขึ้นและมอบเนื้อหาและข้อความทางการตลาดที่มีคุณค่ามากขึ้นให้กับคุณ สําหรับข้อมูลเพิ่มเติมเกี่ยวกับคุกกี้ โปรดดู<a href="/privacy">นโยบายความเป็นส่วนตัว</a>ของเรา การใช้เว็บไซต์นี้ต่อไปแสดงว่าคุณยอมรับการใช้คุกกี้และข้อมูลส่วนบุคคลของเรา',
					'SUB_SUCCESS_TIPS': 'คุณสมัครสมาชิกเรียบร้อยแล้ว',
					'CLOSE': 'ปิด',
					'SUB_ERRO_TIPS': 'โปรดป้อนรูปแบบอีเมลที่ถูกต้อง เช่น xx@xx.com',
					'SUB_PLACEHOLDER': 'Email Address',
				},
				'vn': {
					'FOOTBALL': 'Bóng đá ',
					'SCORE': 'Kết quả',
					'LEAGUES': 'Giải đấu',
					'TRANSFER': 'Chuyển nhượng',
					'PREDICTION': 'Nhận định',
					'NEWS': 'Tin tức',
					'ABOUT': 'Về',
					'TERMS': 'Điều khoản dịch vụ',
					'PRIVACY': 'Chính sách quyền riêng tư',
					'SITMAP': 'Sơ đồ trang web',
					'FOLLOW_US': 'Theo dõi chúng tôi',
					'SUB_TITLE': 'Thông báo đăng ký',
					'SUB_INTRO': 'Thường xuyên nhận được những nội dung ngắn gọn về tin tức giải đấu, phân tích sự kiện, trận đấu hấp dẫn, và hoạt đồng tiếp thị gần đây, giúp vipgoal thiết lập quan hệ sâu sắc hơn với những người hâm mộ.',
					'SUB_BTN': 'Đăng ký',
					'NOTE': 'Lưu ý: Quảng cáo trên upgoal.com được hai bên thỏa thuận trong hợp đồng. Vipgoal không đảm bảo tính xác thực của thông tin trong các quảng cáo trên. Vipgoal không chịu trách nhiệm về mọi giao dịch giữa bạn và nhà quảng cáo.',
					'COPY_RIGHT': '©2024 Bản quyền thuộc về upgoal.com',
					'COOKIE_TIPS': 'Chúng tôi sử dụng Cookie để đảm bảo chức năng cơ bản và thu thập dữ liệu ẩn danh để phân tích, nhằm cải thiện trải nghiệm của bạn. Bằng cách hiểu cách bạn sử dụng sản phẩm của chúng tôi, chúng tôi có thể xây dựng các tính năng tốt hơn và cung cấp nội dung cũng như thông tin tiếp thị có giá trị hơn cho bạn. Để biết thêm thông tin về Cookie, hãy xem <a href="/privacy">Chính sách quyền riêng tư</a> của chúng tôi, nếu tiếp tục sử dụng trang web này, bạn đồng ý với việc chúng tôi sử dụng cookie và các thông tin cá nhân.',
					'SUB_SUCCESS_TIPS': 'Bạn đã đặng ký thành công',
					'CLOSE': 'Đóng',
					'SUB_ERRO_TIPS': 'Hãy nhập Email chính xác, ví dụ như: xx@xx.com',
					'SUB_PLACEHOLDER': 'Email Address',
				}
			},
			index: {
				'en': {
					'LIVE_TAB': [
						{
							'id': 0,
							'name': 'All'
						},
						{
							'id': 1,
							'name': 'Live'
						},
						{
							'id': 2,
							'name': 'Odds'
						},
						{
							'id': 3,
							'name': 'FT'
						},
						{
							'id': 4,
							'name': 'Scheduled'
						}
					],
					'ODDS_TYPE_ARR': ['threeWayLuckMatch', 'asianLuckMatch', 'totalLuckMatch'],
					'LINEUP_POST': 'The official line-up of this game is posted.',
					'TIPS_PRO': 'Tips are provided for this game.',
					'STANDING': 'Standings',
					'ADD_MY_FAVORITES': '<div class="flex flex-align-center"><a href="/favorites" class="flex flex-align-center favPop"><span>Added to My Favorites.</span><i class="icon-font icon-arr favArr"></i></a></div>',
					'REMOVED_MY_FAVORITES': '<div><span>Removed from My Favorites.</span></div>',
					'ADD_MY_LEAGUES': '<div class="flex flex-align-center"><a class="flex flex-align-center favPop"><span>Added to My Leagues.</span></a></div>',
					'REMOVED_MY_LEAGUES': '<div><span>Removed from My Leagues.</span></div>',
					'DISPLAY_MATCHES': 'Display Matches',
					'ODDS_TYPE_TAB': [
						{
							id: 2,
							name: 'AH'
						},
						{
							id: 3,
							name: 'O/U'
						},
						{
							id: 1,
							name: '1x2'
						},
						{
							id: 4,
							name: 'Close'
						},
					]
				},
				'kr': {
					'LIVE_TAB': [
						{
							'id': 0,
							'name': '모두'
						},
						{
							'id': 1,
							'name': '라이브'
						},
						{
							'id': 2,
							'name': '승률'
						},
						{
							'id': 3,
							'name': 'FT'
						},
						{
							'id': 4,
							'name': '스케줄'
						}
					],
					'ODDS_TYPE_ARR': ['threeWayLuckMatch', 'asianLuckMatch', 'totalLuckMatch'],
					'LINEUP_POST': '이번 경기는 정식 라인업이 나왔습니다. ',
					'TIPS_PRO': '이번 경기는 정보를 제공합니다. ',
					'STANDING': '순위',
					'ADD_MY_FAVORITES': '<div class="flex flex-align-center"><a href="/favorites" class="flex flex-align-center favPop"><span>My Favorites에 추가됨</span><i class="icon-font icon-arr favArr"></i></a></div>',
					'REMOVED_MY_FAVORITES': '<div><span>My Favorites에 삭제됨</span></div>',
					'ADD_MY_LEAGUES': '<div class="flex flex-align-center"><a class="flex flex-align-center favPop"><span>내 리그에 추가됨</span></a></div>',
					'REMOVED_MY_LEAGUES': '<div><span>내 리그에 삭제됨</span></div>',
					'DISPLAY_MATCHES': '경기 표시',
					'ODDS_TYPE_TAB': [
						{
							id: 2,
							name: 'AH'
						},
						{
							id: 3,
							name: 'O/U'
						},
						{
							id: 1,
							name: '1x2'
						},
						{
							id: 4,
							name: '닫기'
						},
					]
				},
				'th': {
					'LIVE_TAB': [
						{
							'id': 0,
							'name': 'ทั้งหมด'
						},
						{
							'id': 1,
							'name': 'สด'
						},
						{
							'id': 2,
							'name': 'ราคา'
						},
						{
							'id': 3,
							'name': 'FT'
						},
						{
							'id': 4,
							'name': 'Schedule'
						}
					],
					'ODDS_TYPE_ARR': ['threeWayLuckMatch', 'asianLuckMatch', 'totalLuckMatch'],
					'LINEUP_POST': 'ประกาศไลน์อัพทีมในเกมนี้แล้ว',
					'TIPS_PRO': 'มีทีเด็ดสำหรับเกมนี้',
					'STANDING': 'ตารางคะแนน',
					'ADD_MY_FAVORITES': '<div class="flex flex-align-center"><a href="/favorites" class="flex flex-align-center favPop"><span>เพิ่มแล้วในรายการโปรดของฉัน</span><i class="icon-font icon-arr favArr"></i></a></div>',
					'REMOVED_MY_FAVORITES': '<div><span>ลบออกจากรายการโปรดของฉันแล้ว</span></div>',
					'ADD_MY_LEAGUES': '<div class="flex flex-align-center"><a class="flex flex-align-center favPop"><span>เพิ่มลงในลีกของฉัน</span></a></div>',
					'REMOVED_MY_LEAGUES': '<div><span>ออกจากลีกของฉัน</span></div>',
					'DISPLAY_MATCHES': 'แสดงการแข่งขัน',
					'ODDS_TYPE_TAB': [
						{
							id: 2,
							name: 'AH'
						},
						{
							id: 3,
							name: 'O/U'
						},
						{
							id: 1,
							name: '1x2'
						},
						{
							id: 4,
							name: 'ปิด'
						},
					]
				},
				'vn': {
					'LIVE_TAB': [
						{
							'id': 0,
							'name': 'Toàn bộ'
						},
						{
							'id': 1,
							'name': 'Live'
						},
						{
							'id': 2,
							'name': 'Tỷ lệ'
						},
						{
							'id': 3,
							'name': 'FT'
						},
						{
							'id': 4,
							'name': 'Lịch thi đấu'
						}
					],
					'ODDS_TYPE_ARR': ['threeWayLuckMatch', 'asianLuckMatch', 'totalLuckMatch'],
					'LINEUP_POST': 'Đội hình chính thức đã được công bố',
					'TIPS_PRO': 'Trận đấu này cung cấp nhận định',
					'STANDING': 'Bảng xếp hạng',
					'ADD_MY_FAVORITES': '<div class="flex flex-align-center"><a href="/favorites" class="flex flex-align-center favPop"><span>Đã thêm vào My Favorites</span><i class="icon-font icon-arr favArr"></i></a></div>',
					'REMOVED_MY_FAVORITES': '<div><span>Đã xóa khỏi từ My Favorites</span></div>',
					'ADD_MY_LEAGUES': '<div class="flex flex-align-center"><a class="flex flex-align-center favPop"><span>Đã thêm vào mục Yêu thích của tôi</span></a></div>',
					'REMOVED_MY_LEAGUES': '<div><span>Xóa khỏi mục Yêu thích của tôi</span></div>',
					'DISPLAY_MATCHES': 'Hiển thị các trận đấu',
					'ODDS_TYPE_TAB': [
						{
							id: 2,
							name: 'AH'
						},
						{
							id: 3,
							name: 'O/U'
						},
						{
							id: 1,
							name: '1x2'
						},
						{
							id: 4,
							name: 'Đóng'
						},
					]
				}
			},
			favorites: {
				'en': {
					'FILTER_TAB': [
						{
							'id': 0,
							'name': 'Timeline'
						},
						{
							'id': 1,
							'name': 'Yesterday'
						},
						{
							'id': 2,
							'name': 'Live'
						}
					],
					'UNFOLLOW_TIPS': 'Are you sure to unfollow the match?',
					'UNFOLLOW': 'Unfollow',
					'CLOSE': 'Close'
				},
				'kr': {
					'FILTER_TAB': [
						{
							'id': 0,
							'name': '시간표'
						},
						{
							'id': 1,
							'name': '어제'
						},
						{
							'id': 2,
							'name': '라이브'
						}
					],
					'UNFOLLOW_TIPS': '해당 경기 팔로우를 취소하시겠습니까?',
					'UNFOLLOW': '팔로우 취소',
					'CLOSE': '닫기'
				},
				'th': {
					'FILTER_TAB': [
						{
							'id': 0,
							'name': 'Timeline'
						},
						{
							'id': 1,
							'name': 'เมื่อวาน'
						},
						{
							'id': 2,
							'name': 'สด'
						}
					],
					'UNFOLLOW_TIPS': 'คุณแน่ใจหรือว่าจะเลิกติดตามการแข่งขัน?',
					'UNFOLLOW': 'เลิกติดตาม',
					'CLOSE': 'ปิด'
				},
				'vn': {
					'FILTER_TAB': [
						{
							'id': 0,
							'name': 'Dòng thời gian'
						},
						{
							'id': 1,
							'name': 'Hôm qua'
						},
						{
							'id': 2,
							'name': 'Live'
						}
					],
					'UNFOLLOW_TIPS': 'Bạn có xác định hủy theo dõi trận đấu này không?',
					'UNFOLLOW': 'Hủy theo dõi',
					'CLOSE': 'Đóng'
				}
			},
			details: {
				'en': {
					//
					'REMARKS': {
						'90min': '90 minutes ?1-?2',
						'first': 'First Leg ?1-?2',
						'second': 'Aggregated ?1-?2',
						'120min': '120 minutes ?1-?2',
						'penalyty': 'Penalty Shootout ?1-?2',
					},
					'PROBABILITY': {
						'card_again': 'Probability of another card.',//再获得罚牌概率
						'card_first': 'Probability distribution of first card.',//首罚概率分布
						'goal_again': 'Probability of another goal.',//再进球概率
						'goal_first': 'Probability distribution of first goal.',//首入球概率分布
					},
					'EVENT_SUMMARY': {
						1: 'Goals scored',//'进球'
						2: 'Penalty  ',//'点球',
						3: 'Own goals',//'乌龙球',
						4: 'Yellow card',//'黄牌',
						5: '2Y to R',//'两黄变一红',
						6: 'Red card',//'红牌',
						7: 'Substitutions',//'替换球员',
						8: 'Penalty shootout begins!',//'点球大战开始',
						9: 'Penalty scored',//'点球射进',
						10: 'Penalty missed',//'点球射失',
						'-1': ''// 换下（XX球员）
					},
					'PICKERLIST': [{
						value: 'currentSeason',
						name: 'This season'//'本赛季'
					}, {
						value: 'recentTen',
						name: 'The last 10 games'//'近10场'
					}, {
						value: 'recentTwenty',
						name: 'The last 20 games'//'近20场'
					}],
					'COUNT_DOWN': {
						'tomorrow': 'The match starts tomorrow.',//明天开赛
						'after_tomorrow': 'The match starts the day after tomorrow.',//后天开赛
						'nDays': function (n) {
							return 'The match starts in ' + n + ' days.'//N天后开赛
						},
						//5中断 6取消 8加时 11点球 13延期 14腰斩 15待定 
						'5': 'Undetermined',//
						'6': 'Cancel',//
						'13': 'Postponed',//
						'14': 'Abandoned',//
						'15': 'Undetermined',//
					},
					"KEYLIST": {
						'critical_event': 'Key events',//关键事件
					},
					"SUMMARY": {
						'1ST_HALF': '1ST Half',
						'2ST_HALF': '2ND Half',
						'EXTRA_TIME': 'Extra time',
						'PENALTY_SHOOTOUT': 'Penalty shootout',
						'MATCH_INFO': 'Match Info',
						'HOME_AWAY': 'Home/Away',
						'GOALS': 'Goals',
						'CARDS': 'Cards',
					},
					"LINEUP": {
						'critical_event': 'Key events',//关键事件
						'STARTING_LINEUP': 'Starting Lineups',
						'PREDICTED_LINEUP': 'Predicted Lineups',
						'SUBSTITUTIONS': 'Substitutions',
						'THE_BENCH_PLAYERS': 'The bench players'
					},
					"EVENT": {
						0: { name: 'Statistic' },//统计事件
						1: { name: 'The game begins!', title: '1ST Half' },//比赛开始
						3: { name: 'The game begins! ' },//比赛结束
						4: { name: 'The 2nd half begins.', title: '2ND Half' },//下半场开始
						8: { name: 'Penalty' },//获取点球
						9: { name: 'Goals' },//进球
						18: { name: 'Yellow card' },//黄牌
						21: { name: "2Y to R" },// 黄红牌
						22: { name: "Red card" },// 红牌
						23: { name: "Substitutions" },// 替补
						24: {// 伤停补时显示
							name: "",
							text(val) { return 'The match goes into stoppage time, ' + val + ' minutes of time to be added.' }
						},
						26: { name: "Free-Kicks" },// 任意球
						30: { name: "Corner" },// 角球
						31: { name: "Shot Missed (On target)" },// 射正不进
						32: { name: "Off target" },// 射偏
						34: { name: "Injuries" },// 受伤
						40: { name: "Penalty missed" },// 点球射失
						41: { name: "Penalty shootout begins", title: '' },// 点球决胜开始
						115: { name: "End of first half of extra time" },// 加时赛上半场结束
						116: { name: "Extra time begins." },// 加时赛结束
						134: { name: "The 2nd half begins." },// 上半场结束
						135: { name: "Extra time begins.", title: 'Extra time' },// 加时上半场开始
						136: { name: "Start of second half of extra time" },// 加时下半场开始
						137: { name: "Extra time begins." },// 点球进球
						138: { name: "Penalty Missed" },// 点球射失
						156: { name: "Goal confirmed" },// 进球确认(VAR视频裁判事件，0取消进球1确认进球)
						157: { name: "Yellow card upgraded confirmed" },// 罚牌升级确认(VAR视频裁判事件，0不升级1升级)
						158: { name: "No goal confirmed" },// 未进球确认(VAR视频裁判事件，0进球 1未进球)
						159: { name: "Penalty confirmed" },// 点球确认(VAR视频裁判事件，0点球取消1确认点球)
						160: { name: "Red card" },// 红牌确认(VAR视频裁判事件，0红牌取消 1确认红牌)
						161: { name: "No penalty confirmed" },// 不判罚点球确认(VAR视频裁判事件，0判罚点球1不判罚点球)
						162: { name: "Foul player confirmed" },// 犯规球员确认(VAR视频裁判事件，0没有犯规1判罚犯规)
						9999: { name: "Stadium information" },// 球馆信息
					},
					'ODDS': {
						'1x2': '1x2',
						'ASIAN': 'Asian Handicap',
						'OVER_UNDER': 'Over/Under',
						'BOOKMAKERS': 'Bookmakers',
						'GOALS': 'Goals',
						'OVER': 'Over',
						'UNDER': 'Under',
						'INITIAL_ODDS': 'Initial Odds',
						'LIVE_ODDS': 'Live Odds',
						'HISTORY_CHANGE': 'History of Odds Change',
						'WIN_RATE': 'Win Rate',
						'TIME': 'Time',
						'HOME_WIN_RATE': 'Home Win Rate',
						'DRAW_RATE': 'Draw Rate',
						'AWAY_WIN_RATE': 'Away Win Rate',
						'RETURN': 'Return',
						'HOME': 'Home',
						'HANDICAP': 'Handicap',
						'AWAY': 'Away',
						'TOTAL': 'Total',
						'OVER': 'Over',
						'UNDER': 'Under',
						'INITIAL': 'Initial',
						'LIVE': 'Live',
						'PUSH': 'Push'
					},
					'H2H': {
						'H2H_MATCHES': 'Head-to-head',
						'HOME_VS_AWAY': 'Home vs Away',
						'HT': 'HT',
						'FT': 'FT',
						'AH': 'AH',
						'OU': 'O/U',
						'RECENT_RECORD': 'Recent Record',
						'COMPETION': 'Competition',
						'LAST_GAMES': 'Last ?1 games',
						'WON': 'Won',
						'DRAW': 'Draw',
						'LOST': 'Lost',
						'WIN': 'Wins (AH)',
						'PUSH': 'Pushes (AH)',
						'LOSE': 'Losses (AH)',
						'W': 'W',
						'D': 'D',
						'L': 'L',
						'GOAL_SCORED': 'Goals scored per game',
						'GOAL_CONCEDED': 'Goals conceded per game',
						'CLEAN_SHEETS': 'Clean sheets',
						'INDENTICAL_LINES': 'Indentical Lines',
						'TEAM_RECENT_RECORD': '?1 Recent Record',
						'TEAM_INDENTICAL_LINES': '?1 Indentical Lines',
						'INITIAL_ODDS': 'Initial Odds',
						'RESULT_ARR': ["", "W", "", "L", "", "D"],
						'RESULT_ARR2': ["", "O", "", "U", "", "D"],
						'UPCOMING_GAMES': 'Upcoming 3 Games',
						'DAYS_LATER': '?1 Days Later'
					},
					'STANDING': {
						'LIVE_STANDING': 'LIVE STANDING',
						'FORM': 'Form',
						'FULL': 'Full',
						'HOME': 'Home',
						'AWAY': 'Away',
						'ALL': 'All',
						'TABLE_HEAD': [
							"",
							"",
							"Played",
							"W",
							"D",
							"L",
							"GF/GA",
							"GD",
							"PTS",
							"Last Matches",
						]
					},
					'TAB_LIST': {
						'MATCH': 'Match',
						'SUMMARY': 'Summary',
						'STATS': 'Stats',
						'LINEUP': 'Lineups',
						'EVENT': 'Events',
						'ODDS': 'Odds',
						'H2H': 'H2H',
						'STANDING': 'Standings',
						'PREDICTION': 'Prediction'
					},
					'TAB_EVENT': {
						'ALL': 'ALL',
						'GOALS': 'Goals',
						'CORNERS': 'Corners',
						'CARDS': 'Cards'
					},
					'LABEL_TIPS': {
						'HOME': 'Home',
						'AWAY': 'Away',
						'GOALS_SCORED': 'Goal scored',
						'PENALTY': 'Penalty',
						'PENALTY_MISSED': 'Penalty Missed',
						'CORNER': 'Corner',
						'INJURIES': 'Injuries',
						'SUBSITUTIONS': 'Substitutions',
						'STATE': 'State',
						'FREE_KICKS': 'Free-Kicks',
						'SHOT_MISSED': 'Shot Missed (On target)',
						'OFF_TARGET': 'Off target',
						'YELLOW_CARDS': 'Yellow card',
						'RED_CARDS': 'Red card',
						'STATISTIC': 'Statistic',
						'OWN_GOALS': 'Own goal',
						'IN': 'IN',
						'OUT': 'OUT',
						'2Y_TO_R': '2Y to R'
					},
					'PREDICTION': {
						'MASTER_M': 'Master M',
						'PREDICTED_SCORE': 'Predicted Score:',
						'FORTUNE_TELLER': 'Fortune Teller:',
						'AFTER_LOGIN': 'After login, you can check the details.',
						'LOG_IN': 'Log in',
						'NOTE': 'Note: The views expressed above are those of the authors and do not necessarily reflect the view of the site.',
					},
				},
				'kr': {
					//
					'REMARKS': {
						'90min': '90분 ?1-?2',
						'first': '1라운드 ?1-?2',
						'second': '총 스코어 ?1-?2',
						'120min': '120분 ?1-?2',
						'penalyty': '승부차기 ?1-?2',
					},
					'PROBABILITY': {
						'card_again': '다시 페널티 카드 확률',//再获得罚牌概率
						'card_first': '첫 페널티 확률 분포',//首罚概率分布
						'goal_again': '다시 골인 확률',//再进球概率
						'goal_first': '첫 골 확률 분포',//首入球概率分布
					},
					'EVENT_SUMMARY': {
						1: '골인',//'进球'
						2: '페널티 킥  ',//'点球',
						3: '자책골',//'乌龙球',
						4: '옐로카드',//'黄牌',
						5: '2옐로카드=1레드카드',//'两黄变一红',
						6: '레드카드',//'红牌',
						7: '선수교체',//'替换球员',
						8: '승부차기가 시작됩니다.',//'点球大战开始',
						9: 'PK성공',//'点球射进',
						10: 'PK실축',//'点球射失',
						'-1': ''// 换下（XX球员）
					},
					'PICKERLIST': [{
						value: 'currentSeason',
						name: '올 시즌'//'本赛季'
					}, {
						value: 'recentTen',
						name: '최근 10경기'//'近10场'
					}, {
						value: 'recentTwenty',
						name: '최근 20경기'//'近20场'
					}],
					'COUNT_DOWN': {
						'tomorrow': '내일 경기가 시작됩니다. ',//明天开赛
						'after_tomorrow': '모레 경기가 시작됩니다. ',//后天开赛
						'nDays': function (n) {
							return n + '일 후 경기가 시작됩니다. '//N天后开赛
						},
						//5中断 6取消 8加时 11点球 13延期 14腰斩 15待定 
						'5': '중단',//
						'6': '취소',//
						'13': '연기',//
						'14': '차단',//
						'15': '미정',//
					},
					"KEYLIST": {
						'critical_event': '관건 사건',//关键事件
					},
					"SUMMARY": {
						'1ST_HALF': '전반전',
						'2ST_HALF': '후반전',
						'EXTRA_TIME': '연장전',
						'PENALTY_SHOOTOUT': '승부차기가 시작됩니다.',
						'MATCH_INFO': '경기정보',
						'HOME_AWAY': '홈/원정동일',
						'GOALS': '골인',
						'CARDS': '페널티 카드',
					},
					"LINEUP": {
						'critical_event': '관건 사건',//关键事件
						'STARTING_LINEUP': '선발 라인업',
						'PREDICTED_LINEUP': '예상 라인업',
						'SUBSTITUTIONS': '선수교체',
						'THE_BENCH_PLAYERS': '교체선수'
					},
					"EVENT": {
						0: { name: '통계' },//统计事件
						1: { name: '경기가 시작됩니다!', title: '전반전' },//比赛开始
						3: { name: '경기가 시작됩니다!' },//比赛结束
						4: { name: '후반전이 시작됩니다.', title: '후반전' },//下半场开始
						8: { name: '페널티 킥' },//获取点球
						9: { name: '골인' },//进球
						18: { name: '옐로카드' },//黄牌
						21: { name: "2옐로카드=1레드카드" },// 黄红牌
						22: { name: "레드카드" },// 红牌
						23: { name: "선수교체 " },// 替补
						24: {// 伤停补时显示
							name: "",
							text(val) { return '인저리 타임+' + val + '분' }
						},
						26: { name: "프리킥" },// 任意球
						30: { name: "코너킥" },// 角球
						31: { name: "빗나가기(유효 슈팅)" },// 射正不进
						32: { name: "벗어난 슈팅" },// 射偏
						34: { name: "부상" },// 受伤
						40: { name: "PK실축" },// 点球射失
						41: { name: "승부차기 시작", title: '' },// 点球决胜开始
						115: { name: "연장 전반전 종료" },// 加时赛上半场结束
						116: { name: "연장전이 시작됩니다. " },// 加时赛结束
						134: { name: "후반전이 시작됩니다." },// 上半场结束
						135: { name: "연장전이 시작됩니다.", title: '연장전' },// 加时上半场开始
						136: { name: "연장 후반전 시작" },// 加时下半场开始
						137: { name: "연장전이 시작됩니다." },// 点球进球
						138: { name: "PK실축" },// 点球射失
						156: { name: "골인확정" },// 进球确认(VAR视频裁判事件，0取消进球1确认进球)
						157: { name: "옐로카드 업그레이드 확정" },// 罚牌升级确认(VAR视频裁判事件，0不升级1升级)
						158: { name: "골인 없이 확정" },// 未进球确认(VAR视频裁判事件，0进球 1未进球)
						159: { name: "페널티킥 확정" },// 点球确认(VAR视频裁判事件，0点球取消1确认点球)
						160: { name: "레드카드 " },// 红牌确认(VAR视频裁判事件，0红牌取消 1确认红牌)
						161: { name: "페널티킥 없이 확정" },// 不判罚点球确认(VAR视频裁判事件，0判罚点球1不判罚点球)
						162: { name: "파울 선수 확정" },// 犯规球员确认(VAR视频裁判事件，0没有犯规1判罚犯规)
						9999: { name: "경기장 정보" },// 球馆信息
					},
					'ODDS': {
						'1x2': '1x2',
						'ASIAN': '핸디캡',
						'OVER_UNDER': '오버/언더',
						'BOOKMAKERS': '회사',
						'GOALS': '골인',
						'OVER': '오버',
						'UNDER': '언더',
						'INITIAL_ODDS': '처음승률',
						'LIVE_ODDS': '라이브 승률',
						'HISTORY_CHANGE': '승률 변화',
						'WIN_RATE': '승률',
						'TIME': '시간',
						'HOME_WIN_RATE': '홈 승률',
						'DRAW_RATE': '무 확률',
						'AWAY_WIN_RATE': '원정 승률',
						'RETURN': '반환률',
						'HOME': '홈',
						'HANDICAP': '핸디캡',
						'AWAY': '원정',
						'TOTAL': '합계',
						'INITIAL': '처음',
						'LIVE': '스폿',
						'PUSH': '라이브 '
					},
					'H2H': {
						'H2H_MATCHES': '정면승부',
						'HOME_VS_AWAY': '홈/원정 동일',
						'HT': 'HT',
						'FT': 'FT',
						'AH': 'AH',
						'OU': 'O/U',
						'RECENT_RECORD': '최근 전적',
						'COMPETION': '경기 동일',
						'LAST_GAMES': '최근 ?1경기',
						'WON': '승',
						'DRAW': '무',
						'LOST': '패',
						'WIN': '핸디승',
						'PUSH': '핸디무',
						'LOSE': '핸디패',
						'W': '승',
						'D': '무',
						'L': '패',
						'GOAL_SCORED': '경기당 득점',
						'GOAL_CONCEDED': '경기당 실점',
						'CLEAN_SHEETS': '무실점 횟수',
						'INDENTICAL_LINES': '핸디캡 동일',
						'TEAM_RECENT_RECORD': '?1 최근 전적',
						'TEAM_INDENTICAL_LINES': '?1 핸디캡 동일',
						'INITIAL_ODDS': '처음승률',
						'RESULT_ARR': ["", "승", "", "무", "", "패"],
						'RESULT_ARR2': ["", "O", "", "U", "", "D"],
						'UPCOMING_GAMES': '미래 3경기',
						'DAYS_LATER': '?1 일 후'
					},
					'STANDING': {
						'LIVE_STANDING': '순위',
						'FORM': 'Form',
						'FULL': 'Full',
						'HOME': '홈',
						'AWAY': '원정',
						'ALL': '총 경기수',
						'TABLE_HEAD': [
							"팀",
							"",
							"경기",
							"승",
							"무",
							"패",
							"득/실",
							"득실차",
							"승점",
							"최근 전적",
						]
					},
					'TAB_LIST': {
						'MATCH': '경기',
						'SUMMARY': '적요',
						'STATS': '통계',
						'LINEUP': '라인업',
						'EVENT': '사건',
						'ODDS': '승률',
						'H2H': 'H2H',
						'STANDING': '순위',
						'PREDICTION': '예측'
					},
					'TAB_EVENT': {
						'ALL': '모두',
						'GOALS': '골인',
						'CORNERS': '코너킥',
						'CARDS': '카드'
					},
					'LABEL_TIPS': {
						'HOME': '홈',
						'AWAY': '원정',
						'GOALS_SCORED': '골인',
						'PENALTY': '페널티 킥',
						'PENALTY_MISSED': 'PK실축',
						'CORNER': '코너킥',
						'INJURIES': '부상',
						'SUBSITUTIONS': '교체',
						'STATE': '경기 상태',
						'FREE_KICKS': '프리킥',
						'SHOT_MISSED': '빗나가기(유효 슈팅)',
						'OFF_TARGET': '벗어난 슈팅',
						'YELLOW_CARDS': '옐로카드 ',
						'RED_CARDS': '레드카드',
						'STATISTIC': '통계',
						'OWN_GOALS': '자책골',
						'IN': 'IN',
						'OUT': 'OUT',
						'2Y_TO_R': '2옐로카드=1레드카드'
					},
					'PREDICTION': {
						'MASTER_M': 'Master M',
						'PREDICTED_SCORE': '예측 스코어:',
						'FORTUNE_TELLER': 'Fortune Teller:',
						'AFTER_LOGIN': '로그인 후 상세정보를 보실 수 있습니다.',
						'LOG_IN': '로그인',
						'NOTE': '비고: 이상은 작자 개인의 주관적 관점입니다. ',
					},
				},
				'th': {
					//
					'REMARKS': {
						'90min': '90 นาที ?1-?2',
						'first': ' นัดแรก ?1-?2',
						'second': 'นัดที่สอง ?1-?2',
						'120min': '120 นาที ?1-?2',
						'penalyty': 'ดวลจุดโทษ ?1-?2',
					},
					'PROBABILITY': {
						'card_again': 'ความน่าจะเป็นของการติดใบอีก',//再获得罚牌概率
						'card_first': 'การกระจายความน่าจะเป็นของใบแรก',//首罚概率分布
						'goal_again': 'ความน่าจะเป็นของการการได้ประตูอีก',//再进球概率
						'goal_first': 'การกระจายความน่าจะเป็นของประตูแรก',//首入球概率分布
					},
					'EVENT_SUMMARY': {
						1: 'ทำได้ประตู',//'进球'
						2: 'การดวลจุดโทษ  ',//'点球',
						3: 'ทำเข้าประตูตัวเอง',//'乌龙球',
						4: 'ใบเหลือง',//'黄牌',
						5: '2 ใบเหลืองกลายเป็นใบแดง',//'两黄变一红',
						6: 'ใบแดง',//'红牌',
						7: 'เปลี่ยนผู้เล่นเกมนี้',//'替换球员',
						8: 'เริ่มการยิงลูกโทษ',//'点球大战开始',
						9: 'ยิงลูกโทษได้',//'点球射进',
						10: 'ยิงลูกโทษพลาด',//'点球射失',
						'-1': ''// 换下（XX球员）
					},
					'PICKERLIST': [{
						value: 'currentSeason',
						name: 'ฤดูกาลนี้'//'本赛季'
					}, {
						value: 'recentTen',
						name: '10 เกมหลัง'//'近10场'
					}, {
						value: 'recentTwenty',
						name: '20 เกมหลัง'//'近20场'
					}],
					'COUNT_DOWN': {
						'tomorrow': 'เปิดเกมพรุ่งนี้',//明天开赛
						'after_tomorrow': 'เปิดเกมมะรืนนี้',//后天开赛
						'nDays': function (n) {
							return n + 'เปิดเกมวันหลัง'//N天后开赛
						},
						//5中断 6取消 8加时 11点球 13延期 14腰斩 15待定 
						'5': 'หยุดเกม',//
						'6': 'ยกเลิก',//
						'13': 'เลื่อนเวลา',//
						'14': 'ยกเลิก',//
						'15': 'รอเวลา',//
					},
					"KEYLIST": {
						'critical_event': 'เหตุการณ์สำคัญ',//关键事件
					},
					"SUMMARY": {
						'1ST_HALF': 'ครึ่งแรก',
						'2ST_HALF': 'ครึ่งหลัง',
						'EXTRA_TIME': 'ต่อเวลาพิเศษ',
						'PENALTY_SHOOTOUT': 'เริ่มการยิงลูกโทษ',
						'MATCH_INFO': 'ข้อมูลการแข่งขัน',
						'HOME_AWAY': 'เหย้า/เยือน',
						'GOALS': 'ได้ประตู',
						'CARDS': 'ติดใบ',
					},
					"LINEUP": {
						'critical_event': 'เหตุการณ์สำคัญ',//关键事件
						'STARTING_LINEUP': 'ออกสตาท์เป้นตัวจริง',
						'PREDICTED_LINEUP': 'ไลน์อัพที่คาด',
						'SUBSTITUTIONS': 'เปลี่ยนผู้เล่นเกมนี้',
						'THE_BENCH_PLAYERS': 'ตัวสำรองเกมนี้'
					},
					"EVENT": {
						0: { name: 'สถิติ' },//统计事件
						1: { name: 'เริ่มเกม!', title: 'ครึ่งแรก' },//比赛开始
						3: { name: 'เริ่มเกม! ' },//比赛结束
						4: { name: 'ครึ่งหลังเริ่ม', title: 'ครึ่งหลัง' },//下半场开始
						8: { name: 'การดวลจุดโทษ' },//获取点球
						9: { name: 'ได้ประตู' },//进球
						18: { name: 'จำนวนใบเหลือง' },//黄牌
						21: { name: "2 ใบเหลืองกลายเป็นใบแดง" },// 黄红牌
						22: { name: "ใบแดง" },// 红牌
						23: { name: "เปลี่ยนผู้เล่นเกมนี้" },// 替补
						24: {// 伤停补时显示
							name: "",
							text(val) { return 'เกมเข้าสู่ช่วงทดเวลาบาดเจ็บ มีเวลา ' + val + ' นาที' }
						},
						26: { name: "ลูกฟรีคิก" },// 任意球
						30: { name: "ลูกเตะมุม" },// 角球
						31: { name: "ยิงพลาด" },// 射正不进
						32: { name: "ยิงผิดกรอบ" },// 射偏
						34: { name: "บาดเจ็บ" },// 受伤
						40: { name: "ยิงลูกโทษพลาด" },// 点球射失
						41: { name: "การยิงลูกโทษเริ่มต้นแล้ว", title: '' },// 点球决胜开始
						115: { name: "สิ้นสุดครึ่งแรกของเวลาพิเศษ" },// 加时赛上半场结束
						116: { name: "ช่วงต่อเวลาพิเศษเริ่ม" },// 加时赛结束
						134: { name: "ครึ่งหลังเริ่ม" },// 上半场结束
						135: { name: "ช่วงต่อเวลาพิเศษเริ่ม", title: 'ต่อเวลาพิเศษ' },// 加时上半场开始
						136: { name: "เริ่มต้นครึ่งหลังองเวลาพิเศษ " },// 加时下半场开始
						137: { name: "ช่วงต่อเวลาพิเศษเริ่ม" },// 点球进球
						138: { name: "ยิงลูกโทษพลาด" },// 点球射失
						156: { name: "ยืนยันประตู" },// 进球确认(VAR视频裁判事件，0取消进球1确认进球)
						157: { name: "การอัพเกรดการติดใบเหลืองได้รับการยืนยันแล้ว" },// 罚牌升级确认(VAR视频裁判事件，0不升级1升级)
						158: { name: "ยืนยันว่าไม่มีประตู" },// 未进球确认(VAR视频裁判事件，0进球 1未进球)
						159: { name: "ยืนยันการลงโทษ" },// 点球确认(VAR视频裁判事件，0点球取消1确认点球)
						160: { name: "จำนวนใบแดง" },// 红牌确认(VAR视频裁判事件，0红牌取消 1确认红牌)
						161: { name: "ยืนยันว่าไม่มีการลงโทษ" },// 不判罚点球确认(VAR视频裁判事件，0判罚点球1不判罚点球)
						162: { name: "ยืนยันผู้เล่นที่กระทำฟาล" },// 犯规球员确认(VAR视频裁判事件，0没有犯规1判罚犯规)
						9999: { name: "ข้อมูลสนามกีฬา" },// 球馆信息
					},
					'ODDS': {
						'1x2': '1x2',
						'ASIAN': 'แฮนดิแค็ป',
						'OVER_UNDER': 'สูง/ต่ำ',
						'BOOKMAKERS': 'บุ๊คมาร์ก',
						'GOALS': 'ได้ประตู',
						'OVER': 'สูง',
						'UNDER': 'ต่ำ',
						'INITIAL_ODDS': 'ราคาเปิด',
						'LIVE_ODDS': 'ราคาสด',
						'HISTORY_CHANGE': 'ประวัติการเปลี่ยนแปลงราคา',
						'WIN_RATE': 'อัตราชนะ',
						'TIME': 'เวลา',
						'HOME_WIN_RATE': 'อัตราชนะทีมเหย้า',
						'DRAW_RATE': 'อัตราเสมอ',
						'AWAY_WIN_RATE': 'ทีมเยือนชนะ%',
						'RETURN': 'รีเทิร์น',
						'HOME': 'ทีมเหย้า',
						'HANDICAP': 'ราคา',
						'AWAY': 'ทีมเยือน',
						'TOTAL': 'ทั้งหมด',
						'INITIAL': 'เปิด',
						'LIVE': 'สด',
						'PUSH': 'เจ๊า'
					},
					'H2H': {
						'H2H_MATCHES': 'ผลงานเฮดทูเฮด',
						'HOME_VS_AWAY': 'เหย้า vs เยือน',
						'HT': 'HT',
						'FT': 'FT',
						'AH': 'AH',
						'OU': 'O/U',
						'RECENT_RECORD': 'ผลงานช่วงหลัง',
						'COMPETION': 'การแข่งขัน',
						'LAST_GAMES': '?1 เกมหลัง',
						'WON': 'ชนะ',
						'DRAW': 'เสมอ',
						'LOST': 'แพ้',
						'WIN': 'ได้ราคา',
						'PUSH': 'เจ๊า',
						'LOSE': 'เสียราคา',
						'W': 'ชนะ',
						'D': 'เสมอ',
						'L': 'แพ้',
						'GOAL_SCORED': 'เฉลี่ยได้ประตูต่อนัด',
						'GOAL_CONCEDED': 'เฉลี่ยเสียประตูต่อนัด',
						'CLEAN_SHEETS': 'จำนวนนัดที่เก็บครีนชีท',
						'INDENTICAL_LINES': 'เกมที่ราคาเท่ากัน',
						'TEAM_RECENT_RECORD': '?1 ผลงานช่วงหลัง',
						'TEAM_INDENTICAL_LINES': '?1 เกมที่ราคาเท่ากัน',
						'INITIAL_ODDS': 'ราคาเปิด',
						'RESULT_ARR': ["", "ชนะ", "", "เสมอ", "", "แพ้"],
						'RESULT_ARR2': ["", "O", "", "U", "", "D"],
						'UPCOMING_GAMES': '3 เกมข้างหน้า',
						'DAYS_LATER': '?1 วันหลัง'
					},
					'STANDING': {
						'LIVE_STANDING': 'ตารางคะแนนสด',
						'FORM': 'Form',
						'FULL': 'Full',
						'HOME': 'ทีมเหย้า',
						'AWAY': 'ทีมเยือน',
						'ALL': 'ทั้งหมด',
						'TABLE_HEAD': [
							"ทีม",
							"",
							"แข่ง",
							"ชนะ",
							"เสมอ",
							"แพ้",
							"ได้/เสีย",
							"ประตู+/-",
							"คะแนน",
							"ผลบอลล่าสุด",
						]
					},
					'TAB_LIST': {
						'MATCH': 'การแข่งขัน',
						'SUMMARY': 'สรุป',
						'STATS': 'สถิติ',
						'LINEUP': 'ไลน์อัพ',
						'EVENT': 'เหตุการณ์',
						'ODDS': 'ราคา',
						'H2H': 'H2H',
						'STANDING': 'ตารางคะแนน',
						'PREDICTION': 'ผลการแข่งขันที่คาด'
					},
					'TAB_EVENT': {
						'ALL': 'ทั้งหมด',
						'GOALS': 'ได้ประตู',
						'CORNERS': 'ลูกเตะมุม',
						'CARDS': 'ติดใบ'
					},
					'LABEL_TIPS': {
						'HOME': 'ทีมเหย้า',
						'AWAY': 'ทีมเยือน',
						'GOALS_SCORED': 'ทำได้ประตู',
						'PENALTY': 'การดวลจุดโทษ',
						'PENALTY_MISSED': 'ยิงลูกโทษพลาด',
						'CORNER': 'ลูกเตะมุม',
						'INJURIES': 'บาดเจ็บ',
						'SUBSITUTIONS': 'เปลี่ยนผู้เล่น',
						'STATE': 'สถานะการแข่งขัน',
						'FREE_KICKS': 'ลูกฟรีคิก',
						'SHOT_MISSED': 'ยิงพลาด',
						'OFF_TARGET': 'ยิงผิดกรอบ',
						'YELLOW_CARDS': 'จำนวนใบเหลือง',
						'RED_CARDS': 'จำนวนใบแดง',
						'STATISTIC': 'สถิติ',
						'OWN_GOALS': 'ทำเข้าประตูตัวเอง',
						'IN': 'ลงสนาม',
						'OUT': 'ออกสนาม',
						'2Y_TO_R': '2 ใบเหลืองกลายเป็นใบแดง'
					},
					'PREDICTION': {
						'MASTER_M': 'Master M',
						'PREDICTED_SCORE': 'สกอร์ที่คาด:',
						'FORTUNE_TELLER': 'Fortune Teller:',
						'AFTER_LOGIN': 'คุณสามารถดูรายละเอียดเมื่อคุณเข้าสู่ระบบ',
						'LOG_IN': 'เข้าสู่ระบบ',
						'NOTE': 'หมายเหตุ: ข้อความข้างต้นเป็นความคิดเห็นของผู้เขียน ไม่แสดงถึงความคิดเห็นของเว็บไซต์',
					},
				},
				'vn': {
					//
					'REMARKS': {
						'90min': '90 phút ?1-?2',
						'first': 'Hiệp 1 ?1-?2',
						'second': 'Hiệp 2 ?1-?2',
						'120min': '120 phút ?1-?2',
						'penalyty': 'Luân lưu ?1-?2',
					},
					'PROBABILITY': {
						'card_again': 'Xác suất nhận thêm thẻ phạt',//再获得罚牌概率
						'card_first': 'Phân bố xác suất của thẻ phạt đầu tiên',//首罚概率分布
						'goal_again': 'Xác suất ghi thêm bàn',//再进球概率
						'goal_first': 'Phân bố xác suất của bàn thắng đầu tiên',//首入球概率分布
					},
					'EVENT_SUMMARY': {
						1: 'Ghi bàn',//'进球'
						2: 'Phạt đền',//'点球',
						3: 'Phản lưới nhà',//'乌龙球',
						4: 'Thẻ vàng',//'黄牌',
						5: 'Nhận thẻ vàng thứ 2',//'两黄变一红',
						6: 'Thẻ đỏ',//'红牌',
						7: 'Thay người',//'替换球员',
						8: 'Loạt sút luân lưu bắt đầu!',//'点球大战开始',
						9: 'Ghi bàn từ chấm 11m',//'点球射进',
						10: 'Đá hỏng phạt đền',//'点球射失',
						'-1': ''// 换下（XX球员）
					},
					'PICKERLIST': [{
						value: 'currentSeason',
						name: 'Mùa này'//'本赛季'
					}, {
						value: 'recentTen',
						name: 'Gần 10 trận'//'近10场'
					}, {
						value: 'recentTwenty',
						name: 'Gần 20 trận'//'近20场'
					}],
					'COUNT_DOWN': {
						'tomorrow': 'Bắt đầu vào ngày mai',//明天开赛
						'after_tomorrow': 'Bắt đầu vào ngày kia',//后天开赛
						'nDays': function (n) {
							return 'Bắt đầu ' + n + ' ngày sau'//N天后开赛
						},
						//5中断 6取消 8加时 11点球 13延期 14腰斩 15待定 
						'5': 'Ngừng',//
						'6': 'Hủy',//
						'13': 'Hoãn',//
						'14': 'Cắt ngang',//
						'15': 'Chờ xác định',//
					},
					"KEYLIST": {
						'critical_event': 'Sự kiện quan trọng',//关键事件
					},
					"SUMMARY": {
						'1ST_HALF': 'Hiệp 1',
						'2ST_HALF': 'Hiệp 2',
						'EXTRA_TIME': 'Bù giờ ',
						'PENALTY_SHOOTOUT': 'Loạt sút luân lưu bắt đầu!',
						'MATCH_INFO': 'Thông tin trận đấu',
						'HOME_AWAY': 'Chủ/Khác',
						'GOALS': 'Ghi bàn',
						'CARDS': 'Thẻ phạt',
					},
					"LINEUP": {
						'critical_event': 'Sự kiện quan trọng',//关键事件
						'STARTING_LINEUP': 'Đội hình xuất phát',
						'PREDICTED_LINEUP': 'Đội hình dự kiến',
						'SUBSTITUTIONS': 'Thay người',
						'THE_BENCH_PLAYERS': 'Cầu thủ dự bị'
					},
					"EVENT": {
						0: { name: 'Thống kê' },//统计事件
						1: { name: 'Trận đấu bắt đầu!', title: 'Hiệp 1' },//比赛开始
						3: { name: 'Trận đấu bắt đầu!' },//比赛结束
						4: { name: 'Hiệp 2 bắt đầu', title: 'Hiệp 2' },//下半场开始
						8: { name: 'Phạt đền' },//获取点球
						9: { name: 'Ghi bàn' },//进球
						18: { name: 'Số thẻ vàng' },//黄牌
						21: { name: "Nhận thẻ vàng thứ 2" },// 黄红牌
						22: { name: "Thẻ đỏ" },// 红牌
						23: { name: "Thay người" },// 替补
						24: {// 伤停补时显示
							name: "",
							text(val) { return 'Trận đấu bước vào thời gian bù giờ, có ' + val + ' phút bù giờ' }
						},
						26: { name: "Đá phạt trực tiếp" },// 任意球
						30: { name: "Phạt góc" },// 角球
						31: { name: "Trúng đích" },// 射正不进
						32: { name: "Không trúng đích" },// 射偏
						34: { name: "Chấn thương" },// 受伤
						40: { name: "Đá hỏng phạt đền" },// 点球射失
						41: { name: "Loạt sút luân lưu bắt đầu", title: '' },// 点球决胜开始
						115: { name: "Hiệp phụ thứ 1 kết thúc" },// 加时赛上半场结束
						116: { name: "Hiệp phụ bắt đầu." },// 加时赛结束
						134: { name: "Hiệp 2 bắt đầu." },// 上半场结束
						135: { name: "Hiệp phụ bắt đầu.", title: 'Hiệp phụ' },// 加时上半场开始
						136: { name: "Hiệp phụ thứ 2 bắt đầu" },// 加时下半场开始
						137: { name: "Hiệp phụ bắt đầu." },// 点球进球
						138: { name: "Penalty Missed" },// 点球射失
						156: { name: "Xác nhận bàn thắng" },// 进球确认(VAR视频裁判事件，0取消进球1确认进球)
						157: { name: "Thẻ vàng nâng cấp được xác nhận" },// 罚牌升级确认(VAR视频裁判事件，0不升级1升级)
						158: { name: "Không có bàn thắng được xác nhận" },// 未进球确认(VAR视频裁判事件，0进球 1未进球)
						159: { name: "Phạt đền được xác nhận" },// 点球确认(VAR视频裁判事件，0点球取消1确认点球)
						160: { name: "Số thẻ đỏ" },// 红牌确认(VAR视频裁判事件，0红牌取消 1确认红牌)
						161: { name: "Không phạt đền được xác nhận" },// 不判罚点球确认(VAR视频裁判事件，0判罚点球1不判罚点球)
						162: { name: "Cầu thủ phạm lỗi được xác nhận" },// 犯规球员确认(VAR视频裁判事件，0没有犯规1判罚犯规)
						9999: { name: "Thông tin sân vận động" },// 球馆信息
					},
					'ODDS': {
						'1x2': '1x2',
						'ASIAN': 'Châu Á',
						'OVER_UNDER': 'Tài xỉu ',
						'BOOKMAKERS': 'Nhà cái',
						'GOALS': 'Số bàn thắng',
						'OVER': 'Tài ',
						'UNDER': 'Xỉu',
						'INITIAL_ODDS': 'Kèo ban đầu',
						'LIVE_ODDS': 'Live',
						'HISTORY_CHANGE': 'Xu hướng tỷ lệ',
						'WIN_RATE': 'Tỷ lệ thắng',
						'TIME': 'Thời gian',
						'HOME_WIN_RATE': 'Chủ thắng%',
						'DRAW_RATE': 'Hòa%',
						'AWAY_WIN_RATE': 'Khách thắng%',
						'RETURN': 'Hoàn trả ',
						'HOME': 'Đội chủ',
						'HANDICAP': 'Tỷ lệ kèo',
						'AWAY': 'Đội khách',
						'TOTAL': 'Tổng cộng',
						'INITIAL': 'Ban đầu',
						'LIVE': 'Live',
						'PUSH': 'Hòa'
					},
					'H2H': {
						'H2H_MATCHES': 'Lịch sử đối đầu ',
						'HOME_VS_AWAY': 'Sân/Khách',
						'HT': 'HT',
						'FT': 'FT',
						'AH': 'AH',
						'OU': 'O/U',
						'RECENT_RECORD': 'Phong độ',
						'COMPETION': 'Cùng giải đấu ',
						'LAST_GAMES': 'Gần ?1 trận',
						'WON': 'Thắng ',
						'DRAW': 'Hòa',
						'LOST': 'Bại',
						'WIN': 'Thắng kèo',
						'PUSH': 'Hòa kèo',
						'LOSE': 'Thua kèo',
						'W': 'Thắng',
						'D': 'Hòa',
						'L': 'Thua',
						'GOAL_SCORED': 'Số bàn thắng trung bình',
						'GOAL_CONCEDED': 'Số bàn thua trung bình',
						'CLEAN_SHEETS': 'Số lần sạch lưới',
						'INDENTICAL_LINES': 'Tương tự kèo chấp',
						'TEAM_RECENT_RECORD': '?1 Phong độ',
						'TEAM_INDENTICAL_LINES': '?1 Tương tự kèo chấp',
						'INITIAL_ODDS': 'Cược ban đầu',
						'RESULT_ARR': ["", "T", "", "B", "", "H"],
						'RESULT_ARR2': ["", "O", "", "U", "", "D"],
						'UPCOMING_GAMES': '3 trận tiếp theo ',
						'DAYS_LATER': '?1 ngày sau'
					},
					'STANDING': {
						'LIVE_STANDING': 'Cập nhật bảng xếp hạng',
						'FORM': 'Form',
						'FULL': 'Full',
						'HOME': 'Đội chủ',
						'AWAY': 'Đội khách',
						'ALL': 'Tổng',
						'TABLE_HEAD': [
							"Đội bóng",
							"",
							"Trận",
							"Thắng",
							"Hòa",
							"Bại",
							"Bàn thắng/thua",
							"HS",
							"Điểm",
							"Các trận gần đây",
						]
					},
					'TAB_LIST': {
						'MATCH': 'Trận đấu',
						'SUMMARY': 'Tóm tắt',
						'STATS': 'Thống kê',
						'LINEUP': 'Đội hình',
						'EVENT': 'Sự kiện',
						'ODDS': 'Tỷ lệ',
						'H2H': 'Đối đầu',
						'STANDING': 'Bảng xếp hạng',
						'PREDICTION': 'Nhận định'
					},
					'TAB_EVENT': {
						'ALL': 'Toàn',
						'GOALS': 'Bàn thắng',
						'CORNERS': 'Phạt góc',
						'CARDS': 'Thẻ phạt'
					},
					'LABEL_TIPS': {
						'HOME': 'Đội chủ',
						'AWAY': 'Đội khách',
						'GOALS_SCORED': 'Ghi bàn',
						'PENALTY': 'Phạt đền',
						'PENALTY_MISSED': 'Đá hỏng phạt đền',
						'CORNER': 'Phạt góc',
						'INJURIES': 'Chấn thương',
						'SUBSITUTIONS': 'Thay người',
						'STATE': 'Sự kiện ',
						'FREE_KICKS': 'Đá phạt trực tiếp',
						'SHOT_MISSED': 'Trúng đích',
						'OFF_TARGET': 'Không trúng đích',
						'YELLOW_CARDS': 'Thẻ vàng',
						'RED_CARDS': 'Thẻ đỏ',
						'STATISTIC': 'Thống kê',
						'OWN_GOALS': 'Phản lưới nhà',
						'IN': 'Vào sân',
						'OUT': 'Rời sân',
						'2Y_TO_R': 'Nhận thẻ vàng thứ 2'
					},
					'PREDICTION': {
						'MASTER_M': 'Master M',
						'PREDICTED_SCORE': 'Dự đoán tỷ số:',
						'FORTUNE_TELLER': 'Fortune Teller:',
						'AFTER_LOGIN': 'Đăng nhập để xem thông tin chi tiết',
						'LOG_IN': 'Đăng nhập',
						'NOTE': 'Lưu ý: Quan điểm trên là ý kiến dự đoán riêng của ban biên tập và chỉ có tác dụng tham khảo.',
					},
				}
			},
			leagues: {
				'en': {
					'POINTS': 'Points',
					'AH': 'AH',
					'FIXTURES': 'Fixtures',
					'MORE': 'More',
					'ALL_LEAGUES': 'All Leagues',
					'ORDER': 'Order',
					'OPTIONAL': 'Optional',
					'TOURNAMENT_PHASES': 'Tournament Phases',
					'START_TIME': 'Start Time',
					'OPTIONAL_PHASE': 'Optional Phase',
					'SELECT_ALL': 'Select All',
					'INVERT_SELECTION': 'Invert Selection',
					'CONFIRM': 'Confirm',
					'ALL': 'All',
					'HOME': 'Home',
					'AWAY': 'Away',
					'TABLE_HEAD_POINTS': [
						"Team",
						"Played",
						"W",
						"D",
						"L",
						"GF/GA",
						"GD",
						"PTS",
						"Last Matches",
					],
					'TABLE_HEAD_AH': [
						"Team",
						"Played",
						"Started",
						"HC",
						"W/P/L",
						"Win",
						"Push",
						"Loss",
						"+/-",
						"Winning Rate",
						"Last Matches",
					],
					'COMPETITION_SYSTEM_DESCRIPTION': 'Competition system description',
					'FOOTBALL': 'Soccer',
					'LEAGUES': 'Leagues',
					'ALL_LEAGUES': 'ALL Leagues',
					'TEAMS': 'Teams',
					'PLAYERS': 'Players',
					'FILTER': 'Filter',
					'Results': 'Results',
					'Data': 'Data',
					'Line-up': 'Line-up',
					'Transfer': 'Transfer',
					'Information': 'Information',
				},
				'kr': {
					'POINTS': '승점',
					'AH': '핸디캡',
					'FIXTURES': '경기 일정',
					'MORE': '더 보기',
					'ALL_LEAGUES': '모든 리그',
					'ORDER': '순서',
					'OPTIONAL': '옵션',
					'TOURNAMENT_PHASES': '경기',
					'START_TIME': '시작 시간',
					'OPTIONAL_PHASE': '옵션 단계',
					'SELECT_ALL': '전체',
					'INVERT_SELECTION': '안티 선택',
					'CONFIRM': '확인',
					'ALL': '모두',
					'HOME': '홈',
					'AWAY': '원정',
					'TABLE_HEAD_POINTS': [
						"팀",
						"경기",
						"승",
						"무",
						"패",
						"득/실",
						"골득실차",
						"승점",
						"최근 전적",
					],
					'TABLE_HEAD_AH': [
						"팀",
						"경기",
						"Opened",
						"핸디팀",
						"승/무/패",
						"승",
						"무",
						"패",
						"Win Diff",
						"Rate of win",
						"최근 전적",
					],
					'COMPETITION_SYSTEM_DESCRIPTION': '경기제도',
					'FOOTBALL': '축구',
					'LEAGUES': '리그',
					'ALL_LEAGUES': '모든 리그',
					'TEAMS': '팀 순위',
					'PLAYERS': '선수 순위',
					'FILTER': '검색',
					'Results': '역대전적',
					'Data': '데이터',
					'Line-up': '라인업',
					'Transfer': '이적',
					'Information': '자료',
				},
				'th': {
					'POINTS': 'ตารางคะแนน',
					'AH': 'ราคา',
					'FIXTURES': 'โปรแกรมบอล',
					'MORE': 'แสดงเพิ่มเติม',
					'ALL_LEAGUES': 'ลีกทั้งหมด',
					'ORDER': 'เรียงอันดับ',
					'OPTIONAL': 'คัดเลือก',
					'TOURNAMENT_PHASES': 'ขั้นตอนการแข่งขัน',
					'START_TIME': 'เวลาเริ่มต้น',
					'OPTIONAL_PHASE': 'ขั้นตอนการคัดกรอง',
					'SELECT_ALL': 'เลือกทั้งหมด',
					'INVERT_SELECTION': 'การเลือกกลับ',
					'CONFIRM': 'ยืนยัน',
					'ALL': 'ทั้งหมด',
					'HOME': 'ทีมเหย้า',
					'AWAY': 'ทีมเยือน',
					'TABLE_HEAD_POINTS': [
						"ทีม",
						"แข่ง",
						"ชนะ",
						"เสมอ",
						"แพ้",
						"ได้/เสีย",
						"ประตู+/-",
						"คะแนน",
						"ผลบอลล่าสุด",
					],
					'TABLE_HEAD_AH': [
						"ทีม",
						"แข่ง",
						"เปิด",
						"ทีมต่อได้ราคา",
						"ได้/เจ๊า/เสีย",
						"ได้",
						"เจ๊า",
						"เสีย",
						"ประตู+/-",
						"อัตราการได้ราคา",
						"ผลบอลล่าสุด",
					],
					'COMPETITION_SYSTEM_DESCRIPTION': 'คำอธิบายระบบการแข่งขัน',
					'FOOTBALL': 'ฟุตบอล',
					'LEAGUES': 'ลีก',
					'ALL_LEAGUES': 'ลีกทั้งหมด',
					'TEAMS': 'ตารางทีม',
					'PLAYERS': 'ตารางผู้เล่น',
					'FILTER': 'Filter',
					'Results': 'ผลงานที่ผ่านมา',
					'Data': 'ราคา',
					'Line-up': 'ไลน์อัพการแข่ง',
					'Transfer': 'ตลาดซื้อข่าย',
					'Information': 'ข้อมูล',
				},
				'vn': {
					'POINTS': 'Bảng xếp hạng',
					'AH': 'Tỷ lệ châu Á',
					'FIXTURES': 'Lịch thi đấu',
					'MORE': 'Hiển thị thêm',
					'ALL_LEAGUES': 'Tất cả giải đấu',
					'ORDER': 'Xếp theo',
					'OPTIONAL': 'Sàng chọn',
					'TOURNAMENT_PHASES': 'Giai đoạn giải đấu',
					'START_TIME': 'Thời gian thi đấu',
					'OPTIONAL_PHASE': 'Giai đoạn sàng chọn',
					'SELECT_ALL': 'Chọn cả',
					'INVERT_SELECTION': 'Chọn ngược',
					'CONFIRM': 'Xác nhận',
					'ALL': 'Toàn bộ',
					'HOME': 'Đội chủ',
					'AWAY': 'Đội khách',
					'TABLE_HEAD_POINTS': [
						"Đội bóng",
						"Trận",
						"Thắng",
						"Hòa",
						"Bại",
						"Bàn thắng/thua",
						"HS",
						"Điểm",
						"Các trận gần đây",
					],
					'TABLE_HEAD_AH': [
						"Đội bóng",
						"Trận",
						"Mở",
						"Cửa trên",
						"Thắng/Thua/Hòa",
						"Thắng",
						"Hòa",
						"Bại",
						"+/-",
						"Tỷ lệ thắng kèo",
						"Các trận gần đây",
					],
					'COMPETITION_SYSTEM_DESCRIPTION': 'Thể thức giải đấu',
					'FOOTBALL': 'Bóng đá ',
					'LEAGUES': 'Giải đấu',
					'ALL_LEAGUES': 'Tất cả giải đấu',
					'TEAMS': 'Bảng đội bóng',
					'PLAYERS': 'Bảng cầu thủ',
					'FILTER': 'Tìm kiếm',
					'Results': 'Phong độ',
					'Data': 'Thống kê',
					'Line-up': 'Đội hình',
					'Transfer': 'Chuyển nhượng',
					'Information': 'Dữ liệu',
				}
			},
			privacy: {
				'en': {
					'PRIVACY_TITLE': 'Privacy Policy',
					'PRIVACY_TEXT': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin sapien nunc accuan eget.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin sapien nunc accuan eget.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin sapien nunc accuan eget.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin sapien nunc accuan eget.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra'
				}
			},
			terms: {
				'en': {
					'TERMS_TITLE': 'Terms of Service',
					'TERMS_TEXT': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin sapien nunc accuan eget.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin sapien nunc accuan eget.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin sapien nunc accuan eget.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin sapien nunc accuan eget.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra'
				}
			},
			'404': {
				'en': {
					'BACK': 'Back to home page'
				},
				'kr': {
					'BACK': '홈으로 돌아가기'
				},
				'th': {
					'BACK': 'กลับสู่หน้าหลัก'
				},
				'vn': {
					'BACK': 'Quay lại trang chủ'
				},
			},
			'500': {
				'en': {
					'BACK': 'Back to home page'
				},
				'kr': {
					'BACK': '홈으로 돌아가기'
				},
				'th': {
					'BACK': 'กลับสู่หน้าหลัก'
				},
				'vn': {
					'BACK': 'Quay lại trang chủ'
				},
			},
			news: {
				'en': {
					'ALL': 'All',
					'TOP_NEWS': 'Top News',
					'PREVIOUS': 'Previous',
					'NEXT': 'Next',
					'NEWS': 'News',
					'MAIN_TEXT': 'Main Text',
					'POSTED': '',
					'BY': 'by'
				},
				'kr': {
					'ALL': '모두',
					'TOP_NEWS': '톱 뉴스',
					'PREVIOUS': '앞 페이지',
					'NEXT': '다음 페이지',
					'NEWS': '뉴스',
					'MAIN_TEXT': '본문',
					'POSTED': '',
					'BY': '출처'
				},
				'th': {
					'ALL': 'ทั้งหมด',
					'TOP_NEWS': 'ข่าวเด่น',
					'PREVIOUS': 'ก่อน',
					'NEXT': 'ต่อไป',
					'NEWS': 'ข่าว',
					'MAIN_TEXT': 'ข้อความหลัก',
					'POSTED': '',
					'BY': 'ที่มา'
				},
				'vn': {
					'ALL': 'Toàn bộ',
					'TOP_NEWS': 'Tin nóng',
					'PREVIOUS': 'Trang trước',
					'NEXT': 'Trang sau',
					'NEWS': 'Tin tức',
					'MAIN_TEXT': 'Nội dung chính',
					'POSTED': '',
					'BY': 'Đăng bởi'
				},
			},
			account: {
				'en': {
					'ACCOUNT_INFO': 'Account Information',
					'OLD_PASSWORD': 'Old Password',
					'NEW_PASSWORD': 'New Password',
					'CONFIRM_PASSWORD': 'Confirm Password',
					'EMAIL': 'Email',
					'RESET_SUCCESS': 'Password changed successfully!',
					'PLACEHOLDER_PWD1': 'Leave blank if not changing',
					'PLACEHOLDER_PWD2': 'At least 6 characters',
					'PLACEHOLDER_PWD3': 'Leave blank if not changing',
				},
				'kr': {
					'ACCOUNT_INFO': '계정',
					'OLD_PASSWORD': '비밀번호',
					'NEW_PASSWORD': '새 비밀번호',
					'CONFIRM_PASSWORD': '비밀번호 재확인',
					'EMAIL': '이메일',
					'RESET_SUCCESS': '비밀번호 수정에 성공했습니다!',
					'PLACEHOLDER_PWD1': 'Leave blank if not changing',
					'PLACEHOLDER_PWD2': 'At least 6 characters',
					'PLACEHOLDER_PWD3': 'Leave blank if not changing',
				},
				'th': {
					'ACCOUNT_INFO': 'ข้อมูลบัญชีผู้ใช้งาน',
					'OLD_PASSWORD': 'รหัสผ่านเดิม',
					'NEW_PASSWORD': 'รหัสผ่านใหม่',
					'CONFIRM_PASSWORD': 'ยืนยันรหัสผ่าน',
					'EMAIL': 'อีเมล',
					'RESET_SUCCESS': 'การเปลี่ยนรหัสผ่านสำเร็จแล้ว!',
					'PLACEHOLDER_PWD1': 'Leave blank if not changing',
					'PLACEHOLDER_PWD2': 'At least 6 characters',
					'PLACEHOLDER_PWD3': 'Leave blank if not changing',
				},
				'vn': {
					'ACCOUNT_INFO': 'Thông tin tài khoản',
					'OLD_PASSWORD': 'Mật khẩu cũ',
					'NEW_PASSWORD': 'Mật khẩu mới',
					'CONFIRM_PASSWORD': 'Xác nhận mật khẩu',
					'EMAIL': 'Email',
					'RESET_SUCCESS': 'Đổi mật khẩu thành công!',
					'PLACEHOLDER_PWD1': 'Nếu không thay đổi, hãy để trống',
					'PLACEHOLDER_PWD2': 'Phải dài ít nhất 6 ký tự',
					'PLACEHOLDER_PWD3': 'Nếu không thay đổi, hãy để trống',
				}
			},
		}
	}
}


// WEBPACK FOOTER //
// ./src/utils/langConfig.js